import angular from 'angular';
import loadingAdminListComponent from './loading-admin-list.component';

export default angular.module('components.app.product.loadingAdminList', [])
  .component('loadingAdminList', loadingAdminListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/loading-admin-list/loading-admin-list.module.js